import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "hidden h-screen w-[272px] shrink-0 border-l border-slate-200 bg-white lg:sticky lg:top-0 lg:flex lg:flex-col" }
const _hoisted_2 = { class: "flex items-center gap-3 border-b border-slate-100 px-6 py-6" }
const _hoisted_3 = { class: "flex h-11 w-11 items-center justify-center rounded-2xl bg-cyan-800 text-white shadow-sm" }
const _hoisted_4 = {
  class: "flex-1 space-y-7 overflow-y-auto px-4 py-6",
  "aria-label": "منوی مدیریت"
}
const _hoisted_5 = { class: "mb-2 px-3 text-[11px] font-bold tracking-wide text-slate-400" }
const _hoisted_6 = { class: "space-y-1" }
const _hoisted_7 = { class: "flex-1 text-right" }
const _hoisted_8 = { class: "border-t border-slate-100 p-4" }
const _hoisted_9 = { class: "flex items-center gap-3 rounded-xl bg-slate-50 p-3" }
const _hoisted_10 = { class: "flex h-9 w-9 items-center justify-center rounded-full bg-emerald-100 text-emerald-700" }
const _hoisted_11 = {
  key: 0,
  class: "fixed inset-0 z-[1200] flex lg:hidden",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "منوی مدیریت"
}
const _hoisted_12 = { class: "relative flex h-full w-[min(21rem,calc(100vw-2.5rem))] flex-col bg-white shadow-2xl" }
const _hoisted_13 = { class: "flex items-center justify-between border-b border-slate-100 px-5 py-5" }
const _hoisted_14 = { class: "flex items-center gap-3" }
const _hoisted_15 = { class: "flex h-10 w-10 items-center justify-center rounded-xl bg-cyan-800 text-white" }
const _hoisted_16 = {
  class: "flex-1 space-y-7 overflow-y-auto px-4 py-6",
  "aria-label": "منوی مدیریت"
}
const _hoisted_17 = { class: "mb-2 px-3 text-[11px] font-bold tracking-wide text-slate-400" }
const _hoisted_18 = { class: "space-y-1" }
const _hoisted_19 = { class: "flex-1 text-right" }
const _hoisted_20 = { class: "border-t border-slate-100 p-4" }
const _hoisted_21 = { class: "flex items-center gap-3 rounded-xl bg-slate-50 p-3" }
const _hoisted_22 = { class: "flex h-9 w-9 items-center justify-center rounded-full bg-emerald-100 text-emerald-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_v_icon, { size: "25" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-currency-usd", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "min-w-0 text-right" }, [
          _createElementVNode("p", { class: "truncate text-base font-extrabold tracking-tight text-slate-900" }, "sayyarpay"),
          _createElementVNode("p", { class: "mt-0.5 text-xs font-medium text-slate-500" }, "پنل مدیریت")
        ], -1))
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuGroups, (group) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.title
          }, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(group.title), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.name,
                  to: { name: item.name },
                  class: _normalizeClass(["group flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-semibold transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2", _ctx.isActive(item) ? 'bg-cyan-50 text-cyan-900' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900']),
                  "aria-current": _ctx.isActive(item) ? 'page' : undefined
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["flex h-9 w-9 shrink-0 items-center justify-center rounded-lg transition-colors", _ctx.isActive(item) ? 'bg-cyan-800 text-white' : 'bg-slate-100 text-slate-500 group-hover:bg-white group-hover:text-cyan-800'])
                    }, [
                      _createVNode(_component_v_icon, { size: "19" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.icon), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ], 2),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1),
                    (_ctx.isActive(item))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "16",
                          class: "text-cyan-800"
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-chevron-left", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to", "class", "aria-current"]))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-shield-check", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "min-w-0 text-right" }, [
            _createElementVNode("p", { class: "text-xs font-bold text-slate-700" }, "اتصال امن"),
            _createElementVNode("p", { class: "mt-0.5 text-[11px] text-slate-500" }, "دسترسی مدیر فعال است")
          ], -1))
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "sidebar" }, {
      default: _withCtx(() => [
        (_ctx.sidebarStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "absolute inset-0 bg-slate-950/45 backdrop-blur-[2px]",
                "aria-label": "بستن منو",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
              }),
              _createElementVNode("aside", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_v_icon, { size: "23" }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("mdi-currency-usd", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-right" }, [
                      _createElementVNode("p", { class: "text-sm font-extrabold text-slate-900" }, "sayyarpay"),
                      _createElementVNode("p", { class: "text-xs text-slate-500" }, "پنل مدیریت")
                    ], -1))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "flex h-9 w-9 items-center justify-center rounded-lg text-slate-500 transition hover:bg-slate-100",
                    "aria-label": "بستن منو",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args)))
                  }, [
                    _createVNode(_component_v_icon, { size: "20" }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("nav", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuGroups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.title
                    }, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(group.title), 1),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: item.name,
                            to: { name: item.name },
                            class: _normalizeClass(["group flex items-center gap-3 rounded-xl px-3 py-3 text-sm font-semibold transition-colors", _ctx.isActive(item) ? 'bg-cyan-50 text-cyan-900' : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900']),
                            "aria-current": _ctx.isActive(item) ? 'page' : undefined,
                            onClick: _ctx.closeSidebar
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                class: _normalizeClass(["flex h-9 w-9 shrink-0 items-center justify-center rounded-lg", _ctx.isActive(item) ? 'bg-cyan-800 text-white' : 'bg-slate-100 text-slate-500'])
                              }, [
                                _createVNode(_component_v_icon, { size: "19" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.icon), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 2),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(item.title), 1),
                              (_ctx.isActive(item))
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    size: "16",
                                    class: "text-cyan-800"
                                  }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode("mdi-chevron-left", -1)
                                    ]))]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["to", "class", "aria-current", "onClick"]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("mdi-shield-check", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-right" }, [
                      _createElementVNode("p", { class: "text-xs font-bold text-slate-700" }, "اتصال امن"),
                      _createElementVNode("p", { class: "mt-0.5 text-[11px] text-slate-500" }, "دسترسی مدیر فعال است")
                    ], -1))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}